{
  "Home": "Inicio",
  "Hello World!": "Hola Mundo!",
  "message": "Hola i18n !!",
  "Product": "Producto",
  "Features": "Funcionalidades",
  "About": "Acerca de",
  "Login": "Iniciar sesión",
  "SignUp": "Registrarse",
  "JoinNow": "Unete ahora",
  "Continue": "Continuar",
  "Company": "Empresa",
  "contactUs": "Contáctanos",
  "ineditLong": "Inèdit Software SL",
  "terms": "Términos",
  "Add another": "Añadir otro",
  "mailPlaceholder": "Ej. nombre{'@'}empresa.es",
  "email": "correo",
  "Value is required": "El campo es obligatorio",
  "Value is not a valid email address": "El valor no es una dirección de correo electrónico válida",
  "Search": "Buscar",
  "Manage Workers": "Gestion de trabajadores",
  "Administration": "Administración",
  "Delete": "Eliminar",
  "Confirm": "Confirmar",
  "New print Order": "Nueva orden de impresión",
  "Items": "Artículo|Artículos",
  "Add new": "Añadir nuevo",
  "Write your comments here": "Escribe aquí sus comentarios",
  "File": "Archivo",
  "a new file": "un archivo nuevo",
  "Quantity": "Cantidad",
  "Units": "Unidades",
  "Weak": "Débil",
  "medium": "Medio",
  "strong": "Fuerte",
  "start": {
    "title1": "La manera más fácil de conectar marcas de diseño con centros de impresión",
    "title2": "Inèdit Connect es la manera más fácil, rápida y fiable de recibir, organizar y entregar órdenes de impresión a tus clientes.",
    "description": "Una {0} diseñada para cerrar la brecha {1} o marcas y {2}.",
    "description2": "Esta plataforma tiene como objetivo revolucionar la forma en que abordamos la fabricación, al proporcionar un {0} para la {1}."
  },
  "first": {
    "title": "Primero, dinos tu correo electrónico y contraseña",
    "description": "Será utilizado como administrador de la empresa",
    "agree": "Al continuar, usted acepta nuestros {terms} y que ha leído nuestra {data-use-policy}, incluido el {cookies-use}."
  },
  "second": {
    "title": "Ahora, dinos el nombre de tu empresa",
    "description": "Este será el nombre usado para identificar tu empresa con tus socios"
  },
  "pick-a-password": "Escribe una contraseña",
  "suggestions": "Sugerencias:",
  "Email": "Correo electrónico",
  "Name": "Nombre",
  "Surname": "Apellido",
  "Type": "Tipo",
  "Select Type": "Seleccionar tipo",
  "Address": "Dirección",
  "Street": "Calle",
  "Code": "Código",
  "Cancel": "Cancelar",
  "Save": "Guardar",
  "Printer Mill": "Centro de impresión",
  "Do you want to delete this order?": "¿Quieres eliminar esta orden?",
  "second.description": "Este será el nombre usado para identificar tu empresa con tus socios",
  "Designer Brand": "Marca de diseño",
  "Workflow": "Flujo de trabajo",
  "Preferences": "Preferencias",
  "Application Preferences": "Preferencias de aplicación",
  "third": {
    "title": "Finalmente, añade algunos trabajadores de tu empresa",
    "description": "Podrán ver y gestionar el flujo de trabajo de impresión de tu empresa.",
    "__i18n_ally_root__": {
      "description": "",
      "title": ""
    }
  },
  "otp": {
    "title": "Verifica tu correo electrónico",
    "description": "Hemos enviado un código de verificación a",
    "verify": "Verificar",
    "resend": "Reenviar código"
  },
  "User email must be unique": "El correo electrónico debe ser único",
  "finish_signup": {
    "title": "Casi listo!",
    "description": "Estás a un solo paso de crear tu cuenta!"
  },
  "Your name": "Tu nombre",
  "Number": "Número",
  "City": "Ciudad",
  "Zip": "Código Postal",
  "State": "Provincia",
  "Country": "País",
  "Welcome Back": "Bienvenido de nuevo",
  "Do not have an account?": "¿No tienes una cuenta?",
  "Create today!": " ¡Créala hoy!",
  "Password": "Contraseña",
  "password": "Contraseña",
  "Remember me": "Recuérdame",
  "Log In": "Iniciar sesión",
  "reset_password_description": "Ingrese el correo electrónico asociado con su cuenta y le enviaremos un correo electrónico con un enlace e instrucciones para restablecer su contraseña",
  "Reset your password": "Restablecer su contraseña",
  "Send": "Enviar",
  "Roles": "Roles",
  "New Order": "Nueva Orden",
  "Create": "Crear",
  "View": "Ver",
  "Edit": "Editar",
  "MaterialTypes Management": "Administración de materiales",
  "Price": "Precio",
  "Stock Available": "Stock disponible",
  "Unit": "Unidad",
  "Description": "Descripción",
  "MaterialTypes": "Sustratos",
  "New MaterialType": "Nuevo material",
  "Edit MaterialType": "Editar Material",
  "MaterialType": "Material",
  "Date": "Fecha",
  "Min": "Desde (unidades)",
  "Max": "Hasta",
  "Select units type": "Seleccionar unidades",
  "Yes": "Sí",
  "Manage MaterialTypes": "Administrar sustratos",
  "Roles & Permissions": "Roles y permisos",
  "Please fill in all fields": "Por favor rellena todos los campos",
  "MaterialType deleted successfully": "Sustrato eliminado con éxito",
  "Discard changes": "Descartar los cambios",
  "Changes not saved": "Cambios no guardados",
  "Are you sure you want to exit without saving": "¿Estás seguro de que quieres salir sin guardar?",
  "Company name": "Nombre de empresa",
  "Company alias": "Alias de la empresa",
  "Measure": "Medida",
  "Units of measure": "Unidades de medida",
  "Choose a material first": "Primero elige un material",
  "Split to new order": "Dividir en una nueva orden",
  "Delete Items": "Eliminar objetos",
  "Drag and drop files here to upload": "Arrastra y suelta los archivos aquí para cargarlos.",
  "Comments": "Comentarios",
  "Download": "Descargar",
  "Actions": "Acciones",
  "Replace file": "Reemplazar el archivo",
  "Select or drag and drop in the box below the new file that you want to upload": "Seleccionar o arrastra y suelta en el cuadro de abajo del nuevo archivo que deseas cargar",
  "Api Keys Management": "Gestión de claves API",
  "New token": "Nueva clave",
  "Generate": "Generar",
  "Api_keys_description": "Las claves de API permiten interactuar con nuestra API REST y conectar aplicaciones como Control Center o neoCatalog con Inèdit Connect. \nTen en cuenta que la clave recién generada solo se mostrará una vez, así que asegúrate de copiarla y guardarla en un lugar seguro.",
  "Last Used": "Último uso",
  "Date Created": "Fecha de creación",
  "New Token": "Nueva Clave",
  "Copy": "Copiar",
  "Do you want to delete this token?": "¿Quieres eliminar esta clave?",
  "copies": "Copias",
  "Orders": "Órdenes",
  "forgot_password_description": "Ingrese su correo electrónico a continuación, si es una dirección válida, le enviaremos un correo electrónico con las instrucciones para restablecer su contraseña.",
  "Select Role": "Seleccionar rol",
  "Select Country": "Seleccionar país",
  "Users": "Usuarios",
  "Workflows": "Flujos de trabajo",
  "Materials": "Materiales",
  "Partners": "Socios",
  "Pending": "Pendiente",
  "Discover": "Descubrir",
  "Pending invitations": "Invitaciones pendientes",
  "accept_partnership.title": "Enhorabuena!",
  "accept_partnership.description": "Ahora soys socios de {company}.",
  "Fix the errors in the form before continuing": "Corrige los errores en el formulario antes de continuar",
  "Do you want to delete this item? This action cannot be undone.": "¿Deseas eliminar este elemento? Esta acción no se puede deshacer.",
  "Do you want to delete this items This action cannot be undone": "¿Quieres eliminar estos elementos? Esta acción no se puede deshacer",
  "Order deleted successfully": "Orden eliminada con éxito",
  "There was an error deleting order": "Ha habido un error al eliminar la orden",
  "There was an error creating the MaterialType": "Ha habido un error al crear el material",
  "MaterialType created successfully": "Material creado correctamente",
  "There was an error deleting the MaterialType": "Hubo un error al eliminar el material",
  "MaterialType updated successfully": "Material actualizado con éxito",
  "There was an error updating the MaterialType": "Hubo un error al actualizar el material",
  "Select MaterialType": "Seleccionar material",
  "token_warning": "Esta clave se mostrará solo una vez. Por favor, cópielo y guárdelo en un lugar seguro.",
  "Skip this step. I will add workers later": "Omitir este paso. Agregaré trabajadores más tarde.",
  "There should be at least one Admin user": "Debe haber al menos un usuario administrador",
  "Are you sure you want to delete the selected Users": "¿Estás seguro de que deseas eliminar el usuario seleccionado?|¿Estás seguro de que deseas eliminar los usuarios seleccionados?",
  "File History": "Historial de archivos",
  "no_delete_self": "No puedes borrarte a ti mismo",
  "Please fill in all required fields": "Por favor, rellene todos los campos obligatorios",
  "There are no items for this order please add new items with the button below": "No hay artículos para este pedido, agrega nuevos artículos con el siguiente botón",
  "pagination-text": "Mostrando {last} de {totalRecords} entrada|Mostrando de {first} a {last} de {totalRecords} entradas",
  "no-customers-found": "No se encontraron clientes",
  "loading-customers-data-please-wait": "Cargando datos de clientes. \nEspere por favor.",
  "company description placeholder": "Cuéntanos algo sobre tu empresa para que tus socios puedan conocerte mejor. \nEj.: ¿Qué productos o servicios ofrece tu empresa? \n¿Cómo se destaca tu empresa de la competencia?",
  "Company Address": "Dirección de la empresa",
  "Company information saved": "Información de la empresa guardada",
  "Failed to save company information": "No se pudo guardar la información de la empresa",
  "Company street": "calle de la empresa",
  "Zip Code": "Código postal",
  "Phone number": "Número de teléfono",
  "Role": "Rol",
  "Reject": "Rechazar",
  "Accept": "Aceptar",
  "items_deleted_successfully": "Elemento eliminado con éxito|{count} elementos eliminados con éxito",
  "Users deleted successfully": "Usuario eliminado con éxito|{count} usuarios eliminados con éxito",
  "Select all": "Seleccionar todo",
  "go back to": "volver a {name}",
  "Material Types": "Tipos de material",
  "Manage material types": "Gestionar tipos de materiales",
  "No material types found": "No se encontraron tipos de materiales",
  "Loading material types data": {
    " Please wait": "Cargando datos de tipos de material. \nEspere por favor"
  },
  "No materials found": "No se encontraron materiales",
  "Loading materialTypes data_Please wait": "Cargando datos de materiales. \nEspere por favor",
  "New Material Type": "Nuevo tipo de material",
  "Edit Material": "Editar material",
  "New Material": "Nuevo material",
  "Select Material": "Seleccionar material",
  "Material deleted successfully": "Material eliminado con éxito",
  "There was an error updating the Material": "Hubo un error al actualizar el Material",
  "Length": "Longitud",
  "Select Unit": "Seleccionara unidad",
  "There was an error moving the order": "Hubo un error al mover la orden",
  "Order created successfully": "Orden creada con éxito",
  "No image file": "Item sin archivo",
  "Order edited successfully": "Orden editada correctamente",
  "Workflow saved": "Flujo de trabajo guardado",
  "Error saving workflow": "Error al guardar flujo de trabajo",
  "Workflow Stages": "Etapas del flujo de trabajo",
  "workflowStages_description": "Puede personalizar fácilmente sus flujos de trabajo agregando nuevas etapas.\nSolo debe ingresar el nombre, descripción y orden de cada etapa. \nEsto proporciona flexibilidad y adaptabilidad, permitiendo crear flujos de trabajo que se adaptan a sus necesidades únicas y mejoran la productividad.",
  "Add": "Añadir",
  "Color": "Color",
  "Save changes": "Guardar cambios",
  "Stage updated successfully": "Etapa actualizada con éxito",
  "Stage created successfully": "Etapa creada con éxito",
  "Error updating stage": "Error al actualizar etapa",
  "Error creating stage": "Error al crear la etapa",
  "Do you want to delete this stage": "¿Quieres eliminar esta etapa?",
  "Please save or cancel the changes before editing another stage": "Guarde o cancele los cambios antes de editar otra etapa",
  "Please save or cancel the changes before adding another stage": "Guarde o cancele los cambios antes de agregar otra etapa",
  "Delete Workflow": "Eliminar flujo de trabajo",
  "Default Stage": "Etapa predeterminada",
  "Default workflow stage": "Etapa del flujo de trabajo predeterminada",
  "Workflow deleted": "Flujo de trabajo eliminado",
  "Error deleting workflow": "Error al eliminar el flujo de tr  abajo",
  "Do you want to delete this workflow Changes cant be undone": "¿Desea eliminar este flujo de trabajo? \nEsta acción no se pueden deshacer.",
  "Add workflow": "Agregar flujo de trabajo",
  "Order received to be reviewed and accepted or rejected": "Orden recibida para ser revisada y aceptada o rechazada",
  "Order that has been received": "Orden que se ha recibido",
  "Order is being worked on": "Se está trabajando en la orden",
  "Order has been completed": "La orden se ha completado",
  "Order has been rejected": "La orden ha sido rechazada",
  "Drag and drop orders here to send them to the printer mill": "Arrastra y suelta las órdenes aquí para enviarlos al centro de impresión",
  "Incoming Orders": "Órdenes entrantes",
  "Please enter a reason for rejection": "Por favor, introduzca el motivo del rechazo",
  "New Comment:": "Nuevo comentario:",
  "Unsaved changes": "Cambios no guardados",
  "Continue without saving": "Continuar sin guardar",
  "you-have-unsaved-changes-do-you-want-to-save-or-continue-losing-your-changes": "Tienes cambios sin guardar. \n¿Quieres guardar o seguir sin guardar tus cambios?",
  "No": "No",
  "cant delete workflow with orders": "No se puede eliminar un flujo de trabajo con órdenes",
  "There was an error moving the item": "Hubo un error al mover el item.",
  "Add items first": "Agregar items primero",
  "Default workflow": "Flujo de trabajo predeterminado",
  "Accept partner orders automatically": "Aceptar órdenes de socios automáticamente",
  "Order item has been archived": "El ítem ha sido archivado",
  "Show Archived": "Mostrar archivados",
  "Order item archived successfully": "El ítem archivado con éxito",
  "Error while archiving order item": "Error al archivar el item",
  "Archive": "Archivar",
  "Global Settings": "Ajustes globales",
  "Send to partner": "Enviar a socio",
  "Some items failed to send": "Algunos elementos no se pudieron enviar: {successful}/{total} exitosos",
  "Order items sent to partner": "Elementos enviados al socio: {successful}/{total} exitosos",
  "Failed to send order items to partner": "Error al enviar elementos al socio",
  "Sku": "SKU",
  "Material Type": "Tipo de material",
  "Pieces": "Piezas",
  "Select material type": "Seleccionar tipo de material",
  "Reject order": "Rechazar orden",
  "Order items deleted successfully": "Artículos de la orden eliminados con éxito",
  "Order items archived successfully": "Artículos de la orden archivados con éxito",
  "Go to login page": "Ir a la página de inicio de sesión",
  "Partner preferences saved successfully": "Preferencias de socios guardadas con éxito",
  "Select Columns": "Seleccionar columnas",
  "Columns": "Columnas",
  "Services": "Servicios",
  "Designing": "Diseño",
  "Printing": "Impresión",
  "Activity history": "Historial de Actividades",
  "to": "a",
  "created this order item": "{name} creaste este item|{name} creó este item",
  "created a print job for this order item": "{name} creaste un trabajo de impresión para este item|{name} creó un trabajo de impresión para este item",
  "Delivery Date": "Fecha de entrega",
  "Printers": "Impresoras",
  "No printers found": "No se encontraron impresoras",
  "Loading printers data. Please wait": "Cargando datos de impresoras. \nEspere por favor",
  "are-you-sure-delete-printer": "¿Estás seguro de que deseas eliminar esta impresora?",
  "Printer deleted successfully": "Impresora eliminada con éxito",
  "There was an error deleting the Printer": "Hubo un error al eliminar la impresora",
  "printer deleted successfully": "Impresora eliminada con éxito",
  "URL": "URL",
  "Port": "Puerto",
  "Hidden": "Oculto",
  "Workstation": "Estación de trabajo",
  "UUID": "UUID",
  "No actions selected": {
    " Add actions with button below": "No se han seleccionado acciones. \nAgrega acciones con el siguiente botón."
  },
  "Add Action": "Añadir acción",
  "Select action": "Seleccionara acción",
  "Creation Date": "Fecha de creación",
  "Status": "Estado",
  "Order Code": "Código de orden",
  "Order Name": "Nombre de orden",
  "Object Size": "Tamaño del objeto",
  "Search by code": "Buscar por código",
  "Search by name": "Buscar por nombre",
  "Search by file": "Buscar por archivo",
  "Search by description": "Buscar por descripción",
  "Select actions": "Seleccionar acciones",
  "No partner": "Sin Socio",
  "Order": "Orden",
  "Add Rating": "Agregar calificación",
  "Publish": "Publicar",
  "It will we displayed publicly": "Se mostrará públicamente.",
  "ActivitiesHistory": "Historial de actividades",
  "Order has no items": "La orden no tiene artículos",
  "As the order has no items it will be deleted": "Como la orden no tiene artículos será eliminada",
  "Licenses": "Licencias",
  "Customer": "Cliente",
  "ratings": "reseña|reseñas",
  "Rating saved successfully": "Reseña guardada con éxito",
  "Error while saving rating": "Error al guardar la reseña",
  "No comments yet": "Todavía no hay comentarios",
  "Do you want to delete this order items": "¿Quieres eliminar el ítem?|¿Quieres eliminar los {count} ítems?",
  "Write a review": "Escribe una reseña",
  "Edit review": "Editar reseña",
  "Reply": {
    "": ""
  },
  "Do you want to delete this response": "¿Quieres eliminar esta respuesta?",
  "mail_not_received": "¿No ha recibido el correo electrónico? Compruebe su carpeta de spam o",
  "mail_sent_description": "Le hemos enviado un correo electrónico con instrucciones para restablecer su contraseña.",
  "Something went wrong Please try again later": "Algo ha ido mal. Vuelva a intentarlo más tarde.",
  "couldnt-connect-to-the-server-please-try-again-later": "No se ha podido conectar con el servidor. Vuelva a intentarlo más tarde.",
  "you-are-not-connected-to-the-internet-verify-your-connection-and-then-try-again": "No está conectado a Internet. Verifique su conexión y vuelva a intentarlo.",
  "something-went-wrong-please-try-again-later": "Algo ha ido mal. Vuelva a intentarlo más tarde.",
  "do-you-want-to-delete-this-company": "¿Desea eliminar esta empresa? Se eliminarán todos los datos, incluidos órdenes, usuarios, flujos de trabajo, etc.",
  "we-have-sent-you-an-email-with-instructions-to-delete-your-company-and-all-your-data": "Le hemos enviado un correo electrónico con instrucciones para eliminar su empresa y todos sus datos.",
  "Check your email": "Compruebe su correo electrónico",
  "Ok": "Ok",
  "company-successfully-deleted": "Empresa suprimida con éxito",
  "Logout": "Cerrar sesión",
  "At least one lowercase": "Al menos una minúscula",
  "At least one uppercase": "Al menos una mayúscula",
  "At least one numeric": "Al menos un número",
  "Minimum 8 characters": "Mínimo 8 caracteres",
  "Default Scheme": "Esquema por defecto",
  "Do you want to split this item? A new order with _split suffix will be created": "¿Desea dividir este artículo? Se creará un nuevo pedido con el sufijo _split|¿Desea dividir este artículo? Se creará un nuevo pedido con el sufijo _split",
  "Move to stage": "Pasar a la etapa",
  "This is a test": "Esta es una prueba",
  "centimeters": "Centímetros",
  "in": "in",
  "inches": "Pulgadas",
  "meters": "Metros",
  "name": "nombre",
  "password_reset": {
    "title": "Nueva contraseña",
    "description": "Por favor, introduce tu nueva contraseña a continuación"
  },
  "pixels": "Píxeles",
  "reset_ok": {
    "description": "Ahora puedes iniciar sesión con tu nueva contraseña.",
    "title": "Contraseña recuperada"
  },
  "validations": {
    "alphaNum": "El valor sólo puede contener letras y números.",
    "maxLength": "El campo {property} debe tener una longitud máxima de {max}.",
    "minLength": "El campo {property} debe tener una longitud mínima de {min}.",
    "required": "El campo {property} es obligatorio."
  },
  "Email already taken": "Correo electrónico ya utilizado",
  "Email is required": "Correo electrónico obligatorio",
  "Email is not valid": "El correo electrónico no es válido",
  "now-tell-us-your-company-name": "Dinos el nombre de su empresa",
  "This will be the name used to connect with partners": "Este será el nombre utilizado para conectar con los socios",
  "settings": "Ajustes",
  "Tell us how was the experience with your partner": "Cuéntanos cómo fue la experiencia con tu socio",
  "Partners discovery": "Descubrir socios",
  "Discover new partners": "Descubrir nuevos socios",
  "select-services": "Seleccionar servicios",
  "Showing X results": "Mostrando 0 resultados|Mostrando 1 resultado|Mostrando {count} resultados",
  "Rating": "Valoración",
  "Partners since": "Socios desde",
  "replied": "ha respondido",
  "generic-column-with-no-special-dividers": "Genérico: Columna sin separadores especiales",
  "partners-column-with-sections-for-each-one-of-the-companys-partners": "Socios: Columna con apartados para cada uno de los socios de la empresa.",
  "printers-column-with-sections-for-each-one-of-the-companys-printers": "Impresoras: Columna con apartados para cada una de las impresoras de la empresa.",
  "Drag and drop a file here to upload": "Arrastra y suelta un archivo aquí para cargarlo",
  "material-type-is-required": "El tipo de material es obligatorio",
  "name-is-required": "El nombre es obligatorio.",
  "do-you-want-delete-this-partnership": "¿Deseas eliminar este socio?",
  "submit": "Enviar",
  "please-enter-the-email-address-of-one-of-the-allowed-super-admins-we-will-send-you-an-email-with-instructions-on-how-to-access": "Introduzca la dirección de correo electrónico de uno de los superadministradores autorizados. Le enviaremos un correo electrónico con instrucciones sobre cómo acceder.",
  "email-sent": "Correo electrónico enviado",
  "error-sending-email": "Error al enviar el correo electrónico",
  "There was an error verifying the access token": "Se ha producido un error al verificar la clave de acceso",
  "Only alphanumeric characters are allowed": "Sólo se admiten caracteres alfanuméricos",
  "loading": "Cargando...",
  "alias": "Alias",
  "created": "Creado",
  "Alias": "Alias",
  "Icon": "Icono",
  "Add new service": "Añadir nuevo servicio",
  "Services saved successfully": "Servicios guardados correctamente",
  "There was an error saving the services": "Se ha producido un error al guardar los servicios",
  "Error rejecting invitation": "Error al rechazar la invitación",
  "Error accepting invitation": "Error al aceptar la invitación",
  "You are not authorized to perform this action": "No está autorizado a realizar esta acción",
  "There was an error creating the Order": "Se ha producido un error creando la Orden",
  "There was an error downloading the PDF": "Se ha producido un error descargando el PDF",
  "Partnership rejected successfully": "Solicitud de colaboración rechazada con éxito",
  "Search by units": "Buscar por unidades",
  "Are you sure you want to delete this service": "¿Estás seguro de que deseas eliminar este servicio?",
  "Delete service": "Eliminar servicio",
  "Do you want to archive this order items": "¿Desea archivar este item?|Desea archivar estos items?",
  "no-partners-column": "Para enviar un item a un socio, primero debe crear una columna de \"tipo socio\"",
  "error-uploading-file": "Error al cargar el archivo",
  "file-uploaded-successfully": "Archivo cargado correctamente",
  "Company ratings": "Valoración de la empresa",
  "Error while saving partner preferences": "Error al guardar las preferencias de los socios",
  "Private Comment": "Comentario privado",
  "Public comment": "Comentario público",
  "public-comment-tooltip": "Si este ítem se comparte con un socio, éste podrá ver los comentarios públicos.",
  "Accept partnership": "Aceptar la colaboración",
  "Reject partnership": "Rechazar colaboración",
  "Schemes for": "Esquemas de",
  "Schemes": "Esquemas",
  "Active": "Activo",
  "Public": "Público",
  "Email not allowed": "Correo electrónico no permitido",
  "Scheme files": "Ficheros del esquema",
  "MaterialType with this name already exists": "Tipo de material con este nombre ya existe",
  "Comment deleted successfully": "Comentario eliminado correctamente",
  "There was an error deleting the comment": "Se ha producido un error al borrar el comentario",
  "There was an error editing the": "Se ha producido un error al editar el ",
  "edited_successfully": " editado con éxito",
  "comment": "comentario",
  "Comment": "Comentario",
  "Reset to default": "Restablecer valores por defecto",
  "do-you-want-to-block-this-partnership": "¿Quieres bloquear a este socio?",
  "Block": "Bloquear",
  "Unblock": "Desbloquear",
  "material-edited-successfully": "Material editado correctamente",
  "material-updated-successfully": "Material actualizado correctamente",
  "there-was-an-error-updating-the-material": "Hubo un error al actualizar el material",
  "are-you-sure-you-want-to-delete-this-company": "¿Estás seguro de que deseas eliminar esta empresa?",
  "to-confirm-please-write-delete-on-the-box-below": "Para confirmar, escriba DELETE en la casilla siguiente",
  "Statistics": "Estadísticas",
  "Edited at": "Editado el",
  "Expired": "Caducado",
  "A company already exists with this name": "Ya existe una empresa con este nombre",
  "Analytics": "Analíticas",
  "today": "Hoy",
  "this-month": "Este mes",
  "last-month": "Último mes",
  "this-quarter": "Este trimestre",
  "Meters": "Metros",
  "Total": "Total",
  "By date": "Por fecha",
  "order-items-by-material-type": "Ítems por tipo de material",
  "hello": "Hola",
  "last-30-days": "Últimos 30 días",
  "last-3-months": "Últimos 3 meses",
  "this-year": "Este año",
  "last-365-days": "Últimos 365 días",
  "forgot-password": "¿Ha olvidado su contraseña?",
  "cutting": "Corte",
  "accepted": "Aceptado",
  "idle": "Inactivo",
  "Idle": "Inactivo",
  "In queue": "En cola",
  "Finished": "Terminado",
  "order-items-by-customer": "Ítems por socio",
  "order-items-by-workflow-stage": "Ítems por etapa",
  "Inches": "Pulgadas",
  "Centimeters": "Centímetros",
  "Copies": "Copias",
  "select-status": "Seleccionar estado",
  "No statuses found": "No se han encontrado estados",
  "x-items-selected": "{count} elementos seleccionados",
  "File Name": "Nombre del archivo",
  "User": "Usuario",
  "Manager": "Gerente",
  "Admin": "Admin",
  "Guest": "Invitado",
  "order-items-by-status": "Ítems por estado",
  "send-email-to-owner": "Enviar correo electrónico al propietario",
  "send-email-to-items-owner": "Enviar correo electrónico al propietario del artículo",
  "Generic": "Genérico",
  "EDIT": "EDITAR",
  "VIEW": "VER",
  "CREATE": "CREAR",
  "DELETE": "ELIMINAR",
  "Companies": "Empresas",
  "Permissions": "Permisos",
  "Prices": "Precios",
  "partner": "Socio",
  "Material": "Material",
  "Force touch displays accessibility": "Forzar la accesibilidad de las pantallas táctiles",
  "company-info": "Información de la empresa",
  "company-name-preferences": "Preferencias de {name}",
  "download-csv": "Descargar CSV",
  "cant-delete-item-because-it-has-been-sent-to-a-partner": "No se puede suprimir un artículo porque se ha enviado a un socio",
  "there-was-an-error-deleting-the-item": "Se ha producido un error al eliminar el elemento",
  "select-a-workflow": "Seleccionar flujo de trabajo",
  "TShirt": "Camiseta",
  "Linen": "Lino",
  "Cotton": "Algodón",
  "Tulle": "Tul",
  "TShirt Red": "Camiseta Roja",
  "Silk": "Seda",
  "items-by-company": "Artículos por empresa",
  "users-by-company": "Usuarios por Empresa",
  "x-columns-selected": "{count} columnas seleccionadas",
  "Order items": "Artículos",
  "upcoming-due": "Fecha de vencimiento próxima o vencida",
  "Filter by": "Filtrar por",
  "Dashboard": "Consola",
  "Width": "Anchura",
  "Not specified": "No especificado",
  "Feet": "Pies",
  "Yards": "Yardas",
  "material-width-is-required": "Se requieren unidades",
  "units-required": "Se requieren unidades",
  "Close": "Cerrar",
  "All": "Todos",
  "All orders": "Todas",
  "All order items": "Todos",
  "Yesterday": "Ayer",
  "last-7-days": "Últimos 7 días",
  "quantity-cant-be-0": "La cantidad no puede ser 0",
  "rejected": "Rechazado",
  "no-incoming-items-found": "No se han encontrado órdenes entrantes",
  "Unstarted": "Sin iniciar",
  "Started": "Empezado",
  "Done": "Terminado",
  "Undefined": "Sin definir",
  "Archived": "Archivado",
  "Invite": "Invitar",
  "Starts with": "Empieza por",
  "Contains": "Contiene",
  "Not contains": "No contiene",
  "Ends with": "Termina con",
  "Equals": "Es igual a",
  "Not equals": "No es igual",
  "No Filter": "Sin filtro",
  "Less than": "Menos de",
  "Less than or equal to": "Inferior o igual a",
  "Greater than": "Mayor que",
  "Greater than or equal to": "Mayor o igual que",
  "Date is": "La fecha es",
  "Date is not": "La fecha no es",
  "Date is before": "La fecha es anterior a",
  "Date is after": "La fecha es posterior a",
  "Clear": "Borrar",
  "Apply": "Aplicar",
  "Match All": "Todos deben coincidir",
  "Match Any": "Coincidir con cualquiera",
  "Blocked": "Bloqueados",
  "Manage ink types": "Administrar tipos de tinta",
  "default-workflow-stage-for-incoming-orders-must-be-a-generic-stage": "La etapa predeterminada para las órdenes entrantes debe ser una etapa genérica",
  "a-stage-that-is-set-as-default-of-a-workflow-can-only-be-generic": "Una etapa establecida como predeterminada para flujo de trabajo sólo puede ser Genérica",
  "a-stage-that-is-set-as-default-from-partner-preferences-can-only-be-generic": "Una etapa establecida por defecto en las preferencias de un socio sólo puede ser Genérico",
  "Stage deleted successfully": "Etapa eliminada con éxito",
  "Choose destinataries": "Elegir destinatarios",
  "send-email-to-address": "Enviar correo electrónico a los destinatarios",
  "Send an email to any email address specified": "Envía un correo electrónico a cualquier dirección de correo electrónico especificada",
  "there-was-an-error-creating-the-user": "Se ha producido un error al crear el usuario",
  "User already exists with": "El usuario ya existe con",
  "are-you-sure-delete-ink": "¿Estás seguro de que deseas eliminar esta tinta?|¿Estás seguro de que deseas eliminar estas tintas?",
  "No ink types found": "No se encontraron tipos de tinta",
  "InkType deleted successfully": "Tipo de tinta eliminado correctamente",
  "There was an error deleting the InkType": "Hubo un error al eliminar el tipo de tinta.",
  "New Ink Type": "Nuevo tipo de tinta",
  "InkType created successfully": "Tipo de tinta creado exitosamente",
  "There was an error creating the InkType": "Hubo un error al crear el tipo de tinta.",
  "Search by ink types": "Buscar por tipos de tinta",
  "Select inks type": "Seleccionar tipo de tintas",
  "InkTypes": "Tipos de tinta",
  "permissions-saved": "Permisos guardados",
  "error-saving-permissions": "Error al guardar permisos",
  "you-dont-have-permission-to-perform-this-action": "No tienes permiso para realizar esta acción",
  "View/Edit": "Ver/Editar",
  "length-units": "Unidades de longitud",
  "items": "artículos",
  "Select stage": "Seleccionar una etapa",
  "date-placeholder": "dd/mm/aaaa",
  "file-name": "Nombre del archivo",
  "uploaded-at": "Subido en",
  "accepted-plural": "Aceptados",
  "items_plural": "Artículos",
  "You": "Tu",
  "changed": "cambiado",
  "you-have-changed-field-to-new": " has {verb} {field} a {value}|{name} has {verb} {field} a {value}|{name} ha {verb} {field} a {value}",
  "set": "establecido",
  "and": "y",
  "Workflow Stage": "Etapa",
  "Order Item": "Item",
  "length": "longitud",
  "lengthUnits": "Unidades de longitud",
  "position": "posición",
  "workflow-stage": "etapa",
  "history-position": "la posición",
  "history-status": "el estado",
  "Accepted": "Aceptado",
  "history-width": "la anchura",
  "history-quantity": "la cantidad",
  "history-widthUnits": "las unidades de anchura",
  "history-lengthUnits": "las unidades de longitud",
  "history-length": "la longitud",
  "history-description": "la descripción",
  "email-address": "Dirección de correo electrónico",
  "we-have-detected-that-you-dont-belong-to-any-company": "Hemos detectado que no perteneces a ninguna empresa, puedes crear una nueva o pedir a un administrador de la empresa que te invite",
  "create-new-company": "Crear una nueva empresa",
  "Reason for rejection": "Motivo del rechazo",
  "Error downloading file": "Error al descargar el archivo",
  "Partner": "Socio",
  "Partner Material SKU": "SKU del socio",
  "material-name-partner": "Nombre del material del socio",
  "Deleted": "Suprimido",
  "MaterialType has materials associated with it": {},
  "Cannot delete this Material Type because it has materials associated with it": "No se puede eliminar este tipo de material porque tiene materiales asociados.",
  "Cannot delete this Material because it has order items associated with it": "No se puede eliminar este material porque tiene ítems de orden asociadas.",
  "select-your-company": "Seleccionar tu empresa",
  "we-have-detected-that-you-belong-to-more-than-one-company-please-choose-the-company-you-wish-to-log-in-with": "Hemos detectado que perteneces a más de una empresa. Por favor, elige la empresa con la que deseas iniciar sesión.",
  "Material already exists with": "Ya existe un material con",
  "Sort order": "Orden de ordenación",
  "Sort by": "Ordenar por",
  "Any": "Cualquier",
  "Order items moved to stage": "Ítems movidos al escenario",
  "Role is required": "Se requiere un rol",
  "units-are-required": "Se requieren unidades",
  "Select partner": "Seleccionar un socio",
  "select-sorting-method": "Seleccionar método de clasificación",
  "Encrypted": "Cifrado",
  "Outgoing Orders": "Órdenes de salida",
  "Job": "Trabajo",
  "Encrypt jobs": "Cifrar trabajos",
  "Encrypt outgoing jobs before sending them to your partner": "Cifrar los trabajos salientes antes de enviarlos a tu socio",
  "Send the item file as it is": "Enviar el archivo del ítem tal cual",
  "Send ": {
    "xjb jobs instead of files": "Enviar trabajos .xjb en lugar de archivos"
  },
  "Third Party Licenses": "Licencias de terceros",
  "resolution-x": "Resolución X",
  "resolution-y": "Resolución Y",
  "Height": "Altura",
  "Profile": "Perfil",
  "num-channels": "Núm. canales",
  "num-colorways": "Núm. Coloridos",
  "No image file. Please request the partner to upload the image again.": "Item sin archivo. Solicite al socio que cargue el archivo nuevamente.",
  "file_size_exceeded": "El archivo {name} excede el límite de tamaño de {size} MB",
  "file_type_not_allowed": "Tipo de archivo \"{type}\" no permitido",
  "There is no maximum": "No hay máximo",
  "All the extensions": "Todas las extensiones",
  "Configuration": "Configuración",
  "Allowed file extensions": "Extensiones de archivo permitidas",
  "maximum-file-size-in-megabytes-mb": "Tamaño máximo de archivo en megabytes (MB)",
  "configuration-updated": "Configuración actualizada",
  "error-updating-configuration": "Error al actualizar la configuración",
  "Manage services": "Administrar servicios",
  "Ratings": "Reseñas",
  "Reviews": "Reseñas",
  "Third-party licenses": "Licencias de terceros",
  "third-party-licenses-description": "¡Hola!\nSólo quería haceros saber que hemos estado utilizando algunas bibliotecas y herramientas de terceros impresionantes para ayudarnos a desarrollar nuestro software. Estas licencias de código abierto han sido de gran ayuda para hacer nuestro proyecto más eficiente y robusto. Estamos muy agradecidos por el trabajo duro y la dedicación de los desarrolladores que crearon estas herramientas, y estamos muy contentos de seguir utilizándolas para hacer nuestro proyecto aún mejor.",
  "third-party-software-that-is-part-of-the-web-application": "Software de terceros que forma parte de la aplicación web:",
  "file-too-large": "Tamaño de archivo no válido. El tamaño del archivo debe ser inferior a {maxSize} MB.",
  "Primary": "Principal",
  "Surface": "Superficie",
  "Encrypted in the partner": "Cifrado en el socio",
  "Pending information": "Información pendiente",
  "Table": "Tabla",
  "Compact cards": "Tarjetas compactas",
  "Full sized cards": "Tarjetas de tamaño completo",
  "Custom Fields": "Campos personalizados",
  "Custom Dialogs": "Diálogos personalizados",
  "add-custom-field": "Añadir campo personalizado",
  "field-type": "Tipo de campo",
  "text": "texto",
  "Label": "Etiqueta",
  "Text": "Texto",
  "Boolean": "Booleano",
  "Options": "Opciones",
  "insert-field-available-options": "Escribe y pulsa 'Entrar' para añadir cada opción",
  "custom-field-deleted": "Campo personalizado eliminado",
  "error-deleting-custom-field": "Error al eliminar el campo personalizado",
  "Multiselect": "Multiselección",
  "Dropdown": "Desplegable",
  "default-value": "Valor por defecto",
  "manage-custom-dialogs": "Gestionar diálogos personalizados",
  "add-custom-dialog": "Añadir diálogo personalizado",
  "dialog-title": "Título del diálogo",
  "Title": "Título",
  "this-title-will-be-shown-on-the-dialog-header": "Este título se mostrará en la cabecera del diálogo",
  "No Status": "Sin estado",
  "No Material": "No Material",
  "remove-all-filters": "Eliminar todos los filtros",
  "do-you-want-to-delete-this-item": "¿Desea eliminar este elemento?",
  "Fields": "Campos",
  "Required": "Requerido",
  "Read only": "Sólo lectura",
  "TextArea": "Área de texto",
  "delete-question": "¿Borrar?",
  "this-cant-be-undone": "Este cambio no se puede deshacer",
  "add-new-filed": "Añadir nuevo archivado",
  "select-a-field": "Seleccionar campo",
  "Custom fields": "Campos personalizados",
  "Entity": "Entidad",
  "order-new-custom-field": "orden-nuevo-campo-personalizado",
  "new-custom-field": "Nuevo campo personalizado",
  "New Custom Field": "Nuevo campo personalizado",
  "custom-field-saved": "Campo personalizado guardado correctamente",
  "custom-dialog-saved": "Diálogo personalizado guardado",
  "custom-dialog-save-error": "Error al guardar el diálogo personalizado",
  "Custom field saved": "Campo personalizado guardado",
  "error-saving-custom-field": "Error al guardar un campo personalizado",
  "Su": "Do",
  "Mo": "Lu",
  "Tu": "Ma",
  "We": "Mi",
  "Th": "Ju",
  "Fr": "Vi",
  "Sa": "Sa",
  "January": "Enero",
  "February": "Febrero",
  "March": "Marzo",
  "April": "Abril",
  "May": "Mayo",
  "June": "Junio",
  "July": "Julio",
  "August": "Agosto",
  "September": "Septiembre",
  "October": "Octubre",
  "November": "Noviembre",
  "December": "Diciembre",
  "error-deleting-users": "Error borrando usuario|Error borrando usuarios",
  "or-login": "O Iniciar sesión",
  "project": "Proyecto",
  "about-us": "Quiénes somos",
  "no-available-options": "No hay opciones disponibles",
  "user-created-successfully": "Usuario creado correctamente",
  "Rejected": "Rechazado",
  "Disable job": "Trabajo deshabilitado",
  "Print end": "Impresión finalizada",
  "Print End": "Impresión acabada",
  "error-deleting": "Error al borrar",
  "deleted-successfully": "Eliminado con éxito",
  "Filter": "Filtrar",
  "Ascending": "Ascendente",
  "Descending": "Descendente",
  "select-order": "Seleccionar orden",
  "show-expired": "Mostrar caducados",
  "show-expired-files": "Mostrar archivos caducados",
  "error-resetting-custom-dialog": "Se produjo un error al restablecer el cuadro de diálogo personalizado.",
  "custom-dialog-has-values": "Hay valores establecidos para los campos personalizados de este diálogo.",
  "together": "juntos",
  "lets-print": "Imprimamos {0}!",
  "apply-to-all": "Aplicar a todos",
  "Catalan": "Catalán",
  "Spanish": "Español",
  "English": "Inglés",
  "Italian": "Italiano",
  "search-by-material": "Buscar por material",
  "no-materials-found": "No se encontraron materiales",
  "data-use-policy": "Política de uso de datos",
  "cookies-use": "Uso de cookies",
  "drop-files-here-to-create-a-new-order": "Suelta archivos aquí para crear un nuevo pedido.",
  "drop-files-here": "Suelta archivos aquí",
  "drop-files-here-default-order": "Suelta archivos aquí para un pedido predeterminado",
  "Show less": "Mostrar menos",
  "Show more": "Mostrar más",
  "No information available": "No hay información disponible",
  "Page height": "Alto de página",
  "Page width": "Ancho de página",
  "order-item-moved-to-stage-name-successfully": "El artículo se movió correctamente a la etapa \"{name}\"",
  "send-it-again": "envíalo de nuevo",
  "Move to workflow": "Mover al flujo de trabajo",
  "Sunday": "Domingo",
  "Monday": "Lunes",
  "Tuesday": "Martes",
  "Wednesday": "Miércoles",
  "Thursday": "Jueves",
  "Friday": "Viernes",
  "Saturday": "Sábado",
  "Sun": "Dom",
  "Mon": "Lun",
  "Tue": "Mar",
  "Wed": "Mie",
  "Thu": "Jue",
  "Fri": "Vie",
  "Sat": "Sab",
  "Jan": "Ene",
  "Feb": "Feb",
  "Mar": "Mar",
  "Apr": "Abr",
  "Jun": "Jun",
  "Jul": "Jul",
  "Aug": "Ago",
  "Sep": "Sep",
  "Oct": "Oct",
  "Nov": "Nov",
  "Dec": "Dic",
  "add-order-type": "Agregar tipo de orden",
  "order-type-stage": "Etapa predeterminada",
  "are-you-sure": "¿Estás seguro?",
  "delete-order-type": "Eliminar el tipo de orden",
  "are-you-sure-you-want-to-delete-this-order-type": "¿Estás seguro de que quieres eliminar este tipo de orden?",
  "you-have-unsaved-changes-if-you-leave-now-you-may-lose-yor-changes-are-you-sure-you-want-to-leave": "Tienes cambios no salvos. \nSi te vas ahora, puedes perder tus cambios, ¿estás seguro de que deseas irte?",
  "Order Type": "Tipo de orden",
  "commmunity-platform": "plataforma comunitaria",
  "between-designers": "entre diseñadores",
  "printer-mills": "centros de impresión",
  "follow-us": "Síguenos",
  "centrilized-hub": "centro de conexión",
  "collaboration-communication-and-creativity": "colaboración, comunicación y creatividad",
  "id": "Id",
  "order": "Orden",
  "UpdatedAt": "Actualización",
  "CurrentFile": "Archivo actual",
  "OrderId": "ID de la orden",
  "Line": "Línea",
  "WorkflowStageId": "ID de etapa de flujo de trabajo",
  "ParentId": "ID de la orden padre",
  "CurrentFileId": "ID de archivo actual",
  "Position": "Posición",
  "Order Types": "Tipos de orden",
  "manage-company-and-services-in-administration": "Gestionar la empresa y los servicios en administración",
  "manage-orders-in-workflows-view": "Gestionar pedidos en la vista de flujos de trabajo",
  "manage-roles-and-permissions-in-administration": "Gestionar 'roles y permisos' en la administración",
  "manage-materials-in-administration": "Administrar materiales en la administración",
  "manage-users-in-administration": "Gestiona usuarios en administración",
  "manage-workflows-in-administration": "Gestionar flujos de trabajo en la administración",
  "manage-partners-in-administration-also-manage-partners-in-partners-discovery": "Administrar socios en la administración. \nTambién gestionar los socios en el \"descubrir socios\"",
  "manage-activity-history-of-the-orders-in-workflows-view": "Gestionar el historial de actividades de las ordenes en la vista de flujos de trabajo",
  "information-not-available-for-this-entity": "Información no disponible para esta entidad",
  "Checkbox": "Casilla de selección",
  "Repetitions": "Repeticiones",
  "propagate-units-to-all-items": "Propagar unidades a todos los artículos",
  "default-workflow-stage-for-incoming-orders-cant-be-a-partners-stage": "La etapa de flujo de trabajo predeterminado para pedidos entrantes no puede ser una etapa de tipo 'socios'",
  "Developers": "Desarrolladores",
  "layouts": "Plantillas",
  "no-layouts-found": "No se encontraron plantillas",
  "new-layout": "Nueva Plantilla",
  "layout-name-placeholder": "Nueva plantilla",
  "choose-file": "Elija archivo",
  "upload-layout-file": "Subir el archivo de plantilla",
  "upload-layouts-individually-in-bulk-or-as-a-zip-archive-any-files-with-matching-names-will-be-automatically-updated-with-your-new-versions": "Cargar los diseños individualmente o en grupo. \nCualquier archivo existente con nombres coincidentes se actualizará automáticamente con la nueva versión.",
  "Upload files": "Cargar archivos",
  "Upload": "Subir",
  "Preparing files": "Preparando archivos",
  "Error": "Error",
  "default-layout": "Plantilla predeterminado",
  "default-layout-description": "Esta plantilla se aplicará al pedido al crear el archivo de trabajo.",
  "Layout": "Plantilla",
  "Layout applied": "Diseño aplicado",
  "Layout selected": "Plantilla seleccionada",
  "Number of pages": "Número de páginas",
  "number-of-inputs": "Número de imágenes",
  "allowed-users": "Usuarios permitidos",
  "Visible": "Visible",
  "layout-updated-successfully": "Plantilla actualizada con éxito",
  "attachments": "Adjuntos",
  "show-attachments": "Mostrar archivos adjuntos",
  "layout-cant-be-changed-after-the-order-has-been-created": "La plantilla no se puede cambiar después de que se haya creado la orden",
  "error-accepting-order": "Error al aceptar la orden",
  "order-type-cant-be-changed-after-the-order-has-been-created": "El tipo de orden no se puede cambiar después de que se haya creado el pedido",
  "Layouts": "Plantillas",
  "users-and-access": "Usuarios y acceso",
  "Organization": "Organización",
  "system-configuration": "Configuración del sistema",
  "workflow-&-orders": "Flujo de trabajo y ordenes",
  "Resources": "Recursos",
  "error-saving-the-stage": "Error al guardar la etapa",
  "stage-saved-successfully": "Etapa guardado con éxito",
  "Workflow already exists with same name": "Un flujo de trabajo ya existe con el mismo nombre",
  "accept_partnership": {
    "description": "Ahora soys socios de {company}."
  },
  "Already partners": "Ya es socio",
  "verification-email-sent": "Correo electrónico de verificación enviado",
  "verification-email-description": "Por favor, revisa tu bandeja de entrada y haz clic en el enlace de verificación para activar tu cuenta. Este paso es necesario para completar tu registro y acceder a todas las funciones.",
  "mail_not_received_verification": "¿No recibiste el correo electrónico? Revisa tu carpeta de spam.",
  "user-account-not-verified": "Cuenta de usuario no verificada",
  "sorry-this-user-email-has-not-been-verified-please-check-your-inbox-for-the-verification-email": "Lo siento, este correo electrónico de usuario no ha sido verificado. Por favor, revisa tu bandeja de entrada para el correo electrónico de verificación.",
  "company-is-not-active": "La empresa no está activa",
  "sorry-the-company-you-are-trying-to-access-is-not-active-please-contact-your-company-administrator": "Lo sentimos, la empresa a la que intentas acceder no está activa. Por favor, espera hasta que nuestro equipo de ventas valide esta cuenta.",
  "default-workflow-description": "Al crear un pedido, se colocará automáticamente en este flujo de trabajo.",
  "Optimize jobs": "Optimizar trabajos",
  "some-file-types-are-not-compatible-with-layouts": "Algunos tipos de archivos no son compatibles con la plantilla",
  "supported-file-types-are": "Los tipos de archivos admitidos son",
  "file-type-is-not-supported-in-layouts": "El tipo de archivo no es compatible con la plantilla",
  "failed-to-delete-order-items": "No se pudo eliminar los artículos del pedido",
  "cant-delete-item-because-it-has-children": "No se puede eliminar el artículo porque ha sido aceptado por un socio.",
  "selected-items": "elementos seleccionados",
  "an-order-with-status-accepted-cannot-be-moved": "Una orden con estado \"Aceptado\" no se puede mover",
  "Cannot do this action because at least one item it has been sent to a partner": "No se puede realizar esta acción porque al menos una orden se ha enviado a un socio",
  "there-was-an-error-loading-the-order-items": "Hubo un error al cargar los elementos.",
  "Created by": "Creado por",
  "Created By": "Creado por",
  "Customers": "Clientes",
  "Phone": "Teléfono",
  "new-customer": "Nuevo cliente",
  "are-you-sure-you-want-to-delete-this-customer": "¿Estás seguro de que quieres eliminar a este cliente?",
  "customer-deleted-successfully": "Cliente eliminado exitosamente",
  "send-a-webhook-to-specified-url": "Envía un webhook a la URL especificada",
  "send-webhook": "Enviar webhook",
  "enter-webhook-url": "Ingrese la URL del webhook",
  "Webhook sent": "Webhook enviado",
  "Error sending webhook": "Error al enviar el webhook",
  "Request failed with status code 404": "La solicitud falló con el código de estado 404: No encontrado",
  "webhook-url-is-required": "Se requiere la URL del webhook",
  "pre-process-layout": "Preprocesar plantilla",
  "pre-process-layout-description": "Si se selecciona, la plantilla se preprocesará en la nube para generar un trabajo antes de enviarlo a imprimir. Si no se selecciona, la plantilla se aplicará después de que se envíe a la impresora.",
  "Printer": "Impresora",
  "Scheme": "Esquema",
  "Print automatically": "Imprimir auto",
  "search-by-customer": "Buscar por cliente",
  "search-by-layout": "Buscar por plantilla",
  "search-by-scheme": "Buscar por esquema",
  "search-by-printer": "Buscar por impresora",
  "item": "Artículo",
  "select-printer": "Seleccionar impresora",
  "select-scheme": "Seleccionar esquema",
  "pages": "página|páginas",
  "images": "imagen|imágenes",
  "removed": "eliminado",
  "removed-field": "Se ha eliminado {field}|{name} ha eliminado {field}|{name} ha eliminado {field}",
  "status": "estado",
  "Batch created successfully": "Lote {batchNumber} creado correctamente",
  "Failed to create batch": "No se pudo crear el lote",
  "Cannot create batch with items that already belong to another batch": "No se puede crear un lote con artículos que ya pertenecen a otro lote",
  "Create a batch": "Crear un lote",
  "Manage batch": "Gestionar lote",
  "Cannot mix items with and without batch. Select only items without batch to create, or only items with batch to manage.": "No se pueden mezclar elementos con y sin lote. Selecciona solo elementos sin lote para crear, o solo elementos con lote para gestionar.",
  "Create a new batch with selected items": "Crear un nuevo lote con los elementos seleccionados",
  "Add selected items to an existing batch": "Añadir elementos seleccionados a un lote existente",
  "Remove selected items from their batches": "Eliminar elementos de sus lotes",
  "Remove from batch {batchNumber}": "Eliminar del lote {batchNumber}",
  "Remove from batches {batchNumbers}": "Eliminar de los lotes {batchNumbers}",
  "No items without batch to create batch": "No hay elementos sin lote para crear lote",
  "No items without batch to add": "No hay elementos sin lote para añadir",
  "No items with batch to remove": "No hay elementos con lote para eliminar",
  "Items added to batch successfully": "Elementos añadidos al lote correctamente",
  "Items removed from batch successfully": "Elementos eliminados del lote correctamente",
  "Failed to manage batch": "Error al gestionar el lote",
  "No batch selected": "Ningún lote seleccionado",
  "Items from different batches": "Elementos de diferentes lotes",
  "Batches: {batchNumbers}": "Lotes: {batchNumbers}",
  "Selected items belong to different batches. They will be removed from their current batches.": "Los elementos seleccionados pertenecen a diferentes lotes. Se eliminarán de sus lotes actuales.",
  "the batch number": "el número de lote",
  "Next batch number": "Número de lote siguiente",
  "Last batch created": "Último lote creado",
  "Must be greater than": "Debe ser mayor que",
  "edit-n-items": "Edita 1 elemento|Edita {n} elementos",
  "edit-n-jobs": "Edita 1 trabajo|Edita {n} trabajos",
  "width-units": "Unidades de anchura",
  "Multiple": "Múltiples",
  "none": "Ninguno",
  "MULTIPLE_VALUES_INDICATOR": "Múltiples",
  "there-was-an-error-editing-the-order-items": "Hubo un error al editar los elementos",
  "order-items-updated-successfully": "Artículos actualizados con éxito",
  "search-by-email": "Buscar por correo electrónico",
  "search-by-phone": "Buscar por teléfono",
  "search-by-state": "Buscar por estado",
  "print_progress": "Progreso de impresión",
  "search-by-zip": "Buscar por código postal",
  "search-by-address": "Buscar por dirección",
  "Disable_job": "Deshabilitar trabajo",
  "Do you want to split this ítem? A new order with _split suffix will be created": "",
  "Error while archiving order ítem": "",
  "Order ítem archived successfully": "",
  "Order ítem has been archived": "",
  "Partner Mat": {
    " SKU": "Socio"
  },
  "Preprocess layout": "Diseño previo al proceso",
  "There was an error moving the ítem": "",
  "USER": "Usuario",
  "back-to-login": "Regresar al inicio de sesión",
  "cant-delete-ítem-because-it-has-been-sent-to-a-partner": "",
  "created this order ítem": "",
  "disable_job": "Deshabilitar trabajo",
  "enable_job": "Habilitar trabajo",
  "hey-there-just-wanted-to-let-you-know-that-weve-been-using-some-awesome-third-party-libraries-and-tools-to-help-us-develop-our-software-these-open-source-licenses-have-been-a-huge-help-in-making-our-project-more-efficient-and-effective-were-super-grateful-for-the-hard-work-and-dedication-of-the-developers-who-created-these-tools-and-were-excited-to-keep-using-them-to-make-our-project-even-better": "¡Hola! Solo quería informarte que hemos estado utilizando algunas bibliotecas y herramientas de terceros increíbles para ayudarnos a desarrollar nuestro software. Estas licencias de código abierto han sido de gran ayuda para hacer nuestro proyecto más eficiente y efectivo. Estamos muy agradecidos por el arduo trabajo y la dedicación de los desarrolladores que crearon estas herramientas, ¡y estamos emocionados de seguir utilizándolas para mejorar aún más nuestro proyecto!",
  "in-queue": "En cola",
  "internal-use-field": "Campo de uso interno, no se puede modificar",
  "print_start": "Iniciar impresión",
  "search-by-city": "Buscar por ciudad",
  "search-by-country": "Buscar por país",
  "select-date": "Seleccionar fecha",
  "select-material": "Seleccionar material",
  "there-was-an-error-deleting-the-ítem": "",
  "there-was-an-error-downloading-the-file": "Hubo un error al descargar el archivo",
  "there-was-an-error-fetching-the-layouts": "Hubo un error al buscar los diseños",
  "View all": "Ver todo",
  "by-material": "Por material",
  "by-due-date": "Por fecha de vencimiento",
  "by-creation-date": "Por fecha de creación",
  "by-batch": "Por lote",
  "by-customer": "Por cliente",
  "by-order-type": "Por tipo de orden",
  "Buckets": "Agrupaciones",
  "Batch": "Lote",
  "By": "Por",
  "customer": "cliente",
  "orderType": "tipo de orden",
  "date": "fecha",
  "creationDate": "fecha de creación",
  "without-material": "Sin material",
  "search-by-order-type": "Buscar por tipo de orden",
  "Without": "Sin",
  "this-week": "Esta semana",
  "old": "Vencidas",
  "rest": "Futuras",
  "batch": "lote",
  "no-due-date": "Sin fecha de vencimiento",
  "next-week": "La próxima semana",
  "tomorrow": "Mañana",
  "Search by batch": "Buscar por lote",
  "selected-n-length": "{n} {units} seleccionados",
  "Cards": "Tarjetas",
  "List": "Lista",
  "total-items": "Artículos totales",
  "total-length": "Longitud total",
  "quantity": "cantidad",
  "the quantity": "la cantidad",
  "the width": "el ancho",
  "the length": "la longitud",
  "the widthUnits": "las unidades de anchura",
  "the lengthUnits": "las unidades de longitud",
  "the material": "el material",
  "the workflowStage": "la etapa del flujo de trabajo",
  "the printer": "la impresora",
  "the scheme": "el esquema",
  "the layout": "la plantilla",
  "There are no schemes configured for this printer": "No hay esquemas configurados para esta impresora",
  "Uploads": "Subidas",
  "Clear all": "Borrar todo",
  "No uploads": "Sin cargas",
  "Some order items already have a batch": "Algunos elementos del bucket ya pertenecen a un lote",
  "create-a-batch-with-n-elements-for-this-bucket": "¿Crear un lote con {n} elemento para este bucket?|¿Crear un lote con {n} elementos para este bucket?",
  "Path": "Ruta",
  "Select layout": "Seleccionar plantilla",
  "Select customer": "Seleccionar cliente",
  "select-a-user": "Seleccionar usuario",
  "Order ID": "ID Orden",
  "Item ID": "ID Item",
  "download-pdf": "Descargar PDF",
  "Split PDF": "Dividir PDF",
  "pdf-has-n-pages-split-question": "El PDF \"{name}\" tiene {count} páginas. ¿Quieres dividir cada página en un artículo separado?",
  "Split into separate items": "Dividir en artículos separados",
  "Keep as single item": "Mantener como un solo artículo",
  "Select pages to import": "Seleccionar páginas para importar",
  "Grid view": "Vista de cuadrícula",
  "List view": "Vista de lista",
  "n-pages-selected": "{count} de {total} páginas seleccionadas|{count} de {total} páginas seleccionadas",
  "Import": "Importar",
  "Loading previews...": "Cargando vistas previas...",
  "Connected Devices": "Dispositivos conectados",
  "connect-with-qr-reader": "Conéctate con el lector de QR",
  "2-open-the-app-go-to-setting-click-on-add-button-and-scan-the-qr-code": "2. Abre la aplicación, ve a Configuración, haz clic en el botón '+' y escanea el código QR.",
  "1-download-the-qr-reader-app": "1. Descarga la aplicación QR Reader",
  "move-to-next-stage": "Mover a la siguiente etapa",
  "view-order": "Ver orden",
  "view-batch": "Ver lote",
  "the currentFile": "el archivo",
  "destination": "Destino",
  "printer": "Impresora",
  "Website": "Sitio web",
  "Social Networks": "Redes Sociales",
  "Choose platform": "Seleccionar plataforma",
  "Choose a platform": "Elige una plataforma",
  "URL completa": "URL completa",
  "Network name": "Nombre de la red",
  "Link with user": "Enlace / {'@'}usuario",
  "View website": "Ver página web",
  "Other social network": "Other social network",
  "No social networks added": "No se agregaron redes sociales",
  "Add social network": "Agregar red social",
  "yourusername": "tuusuario",
  "edit-1-item": "Editar 1 elemento",
  "Export": "Exportar",
  "change-action": "Cambiar acción",
  "multiple-values": "Múltiples valores",
  "Printer-updated-successfully": "Impresora actualizada exitosamente",
  "There-was-an-error-updating-the-layout": "Ha habido un error actualizando la plantilla",
  "There-was-an-error-updating-the-printer": "Hubo un error al actualizar la impresora.",
  "Are-you-sure-delete-printers": "¿Está seguro de que desea eliminar las impresoras seleccionadas?",
  "Are-you-sure-delete-printer": "¿Está seguro de que desea eliminar la impresora seleccionada?",
  "Printers deleted successfully": "Impresoras eliminadas con éxito",
  "There-was-an-error-deleting-the-printers": "Hubo un error al eliminar las impresoras.",
  "Materials deleted successfully": "Materiales eliminados exitosamente",
  "There-was-an-error-deleting-the-materials": "Hubo un error al eliminar los materiales.",
  "Are-you-sure-delete-material": "¿Estás seguro de que deseas eliminar el material seleccionado?",
  "Are-you-sure-delete-materials": "¿Está seguro de que desea eliminar los materiales seleccionados?",
  "Loading layouts data": {
    " Please wait": "Cargando datos de diseños. \nEspere por favor"
  },
  "Connect-your-device-to-scan-QR": "Conecte su dispositivo para escanear códigos QR desde archivos PDF e ir directamente a la página de acción del elemento.",
  "Files": "Archivos",
  "Batches": "Lotes",
  "Export PDF": "Exportar PDF",
  "end-date": "Fecha de finalización",
  "aborted-date": "Fecha de interrupción",
  "Done Items": "Elementos completados",
  "jobs": "trabajo|trabajos",
  "send-to-printer": "Enviar a impresora",
  "move-to-printer": "Mover a impresora",
  "Print Jobs": "Trabajos de impresión",
  "Update Date": "Fecha de actualización",
  "select-order-type": "Seleccionar tipo de pedido",
  "select-batch": "Seleccionar lote",
  "search-by-batch": "Buscar por lote",
  "cannot-edit-layout-when-in-printers-or-done-stage": "No se puede editar el diseño en las etapas de tipo 'Impresoras' ni en las del grupo 'Terminado'",
  "cannot-edit-scheme-when-in-printers-or-done-stage": "No se puede editar el esquema en las etapas de tipo 'Impresoras' ni en las del grupo 'Terminado'",
  "cannot-edit-printer-when-in-printers-or-done-stage": "No se puede editar la impresora cuando se está en las etapas de tipo 'Impresoras' ni en las del grupo 'Terminado'",
  "Cannot save with a hidden printer": "No se puede guardar cuando el stage es de tipo 'Impresoras' y la impresora seleccionada no está visible",
  "column-order-not-configured-yet": "El orden de las columnas aún no se ha configurado en 'Configuración'",
  "Reset Order": "Restablecer orden",
  "Order Columns": "Ordenar columnas",
  "Default column order and visibility": "Orden de columnas predeterminado y visibilidad",
  "Configure Columns": "Configurar columnas",
  "Configure default column order": "Configurar el orden de columnas predeterminado",
  "Default Column Order": "Orden de columnas predeterminado",
  "Reorder Columns": "Reordenar columnas",
  "at-least-one-of-the-selected-items-is-currently-in-the-printers-stage-the-attached-print-job-will-be-cancelled-are-you-sure-you-want-to-move-it-out-of-that-stage": "El elemento seleccionado se encuentra actualmente en la etapa Impresoras. El trabajo de impresión adjunto se cancelará si aún no ha comenzado. ¿Está seguro de que desea sacarlo de la etapa?|Al menos uno de los elementos seleccionados se encuentra actualmente en la etapa Impresoras. Los trabajos de impresión adjuntos se cancelarán si aún no han comenzado. ¿Estás seguro de que quieres sacarlos del escenario?",
  "confirm-removing-from-printers-stage": "Confirmar la eliminación de la etapa Impresoras",
  "at-least-one-of-the-selected-items-has-already-been-printed-are-you-sure-you-want-to-move-it-back-to-the-printers-stage": "El elemento seleccionado ya ha sido impreso anteriormente. ¿Estás seguro de que quieres moverlo de nuevo a la etapa Impresoras?|Al menos uno de los elementos seleccionados ya ha sido impreso anteriormente. ¿Estás seguro de que quieres moverlos de nuevo a la etapa Impresoras?",
  "confirm-moving-to-printers-stage": "Confirmar el movimiento a la etapa Impresoras",
  "yes-move-it": "Si, muévelo",
  "no-keep-it": "No, mantenlo",
  "the-selected-item-is-currently-in-the-printers-stage": "El elemento seleccionado se encuentra actualmente en la etapa Impresoras.|Al menos uno de los elementos seleccionados se encuentra actualmente en la etapa Impresoras.",
  "Default printer": "Impresora predeterminada",
  "Default scheme": "Esquema predeterminado",
  "API Tokens & Devices": "Claves y dispositivos API",
  "Starting batch number": "Número de lote inicial (el siguiente lote será este número)",
  "Configure which columns are visible and their default order": "Configure qué columnas son visibles y su orden predeterminado. \nEstas configuraciones se utilizarán como valores de reinicio para todos los usuarios.",
  "archive": "Archivar",
  "cancel-jobs": "Cancelar trabajos",
  "cancel-print-jobs": "Cancelar trabajo de impresión|Cancelar trabajos de impresión",
  "cancel-print-job-disabled": "Sólo es posible cancelar trabajos con el estado 'Pendiente' o 'Asignado'",
  "reason-for-cancelling": "Motivo de la cancelación",
  "enter-reason-for-cancelling": "Ingresa una razón para cancelar el trabajo de impresión|Ingresa una razón para cancelar los trabajos de impresión",
  "do-you-want-to-cancel-these-print-jobs": "¿Desea cancelar este trabajo de impresión?|¿Desea cancelar estos trabajos de impresión?",
  "cancel-print-job-printer-queue-warning": "Cancelar un trabajo de impresión en este estado solo cambiará su estado a CANCELADO en Inèdit Connect. No lo cancelará en la cola de impresión. Si el trabajo sigue en la impresora, deberás eliminarlo manualmente desde la impresora.",
  "i-understand-cancel-print-job-printer-queue-warning": "Entiendo que puede que tenga que eliminar este trabajo manualmente de la cola de la impresora.",
  "print-jobs-cancelled-successfully": "Trabajo de impresión cancelado correctamente|Trabajos de impresión cancelados correctamente",
  "failed-to-cancel-print-jobs": "Error al cancelar los trabajos de impresión",
  "unable-to-confirm-cancellation": "No se pudo confirmar la cancelación",
  "cancel-print-job-timeout-warning": "No se pudo confirmar la cancelación en el tiempo esperado. Es posible que el estado del trabajo no se haya actualizado en la cola de impresión.",
  "confirm-cancellation-anyway": "Confirmar cancelación de todos modos",
  "print-job-in-printer-queue": "Trabajos de impresión en cola de impresora",
  "print-job-in-printer-queue-message": "Al menos uno de los trabajos de impresión seleccionados está actualmente en la cola de impresora. La cancelación se enviará al Control Center para su procesamiento.",
  "jobs-archived-successfully": "Trabajos archivados exitosamente",
  "error-while-archiving-jobs": "Error al archivar trabajos",
  "No tokens yet": "Aún no hay claves",
  "A token with this name already exists": "Ya existe una clave con este nombre; elija un nombre diferente",
  "Error generating token": "Error al generar clave",
  "Enter your token name": "Ingrese el nombre de su clave",
  "Generate a new token": "Generar una nueva clave",
  "Drag to reorder and toggle visibility as your default": "Arrastre para reordenar y alternar la visibilidad. \nEste orden se utilizará como orden de columnas predeterminado.",
  "Drag to reorder and toggle visibility as your company": "Arrastre para reordenar y alternar la visibilidad. \nEsto se convertirá en el valor predeterminado para todos los usuarios cuando restablezcan sus columnas.",
  "customers": "clientes",
  "printer-queue": "Cola de impresora",
  "unassigned-jobs": "Trabajos no asignados",
  "Order Layout": "Plantilla",
  "printJobStatus": {
    "PENDING": "Pendiente",
    "ASSIGNED": "Asignado",
    "PROCESSING": "Procesando",
    "QUEUED": "En cola",
    "PRINTING": "Imprimiendo",
    "COMPLETED": "Completado",
    "ABORTED": "Cancelado",
    "CANCELLED": "Cancelado"
  },
  "printJobType": {
    "PRINT": "Impresión",
    "REPRINT": "Reimpresión",
    "blankSpace": "Espacio en blanco"
  },
  "Select Control Center": "Seleccionar Control Center",
  "save-and-create-job": "Guardar y crear trabajo con plantilla",
  "No items selected": "No hay elementos seleccionados",
  "are-you-sure-you-want-to-delete-this-comment": "¿Estás seguro de que quieres eliminar este comentario?",
  "Choose a printer": "Elige una impresora",
  "Choose a scheme": "Elige un esquema",
  "Download PDF": "Descargar PDF",
  "Error generating the job of the order": "Error al generar el trabajo del pedido",
  "Error generating the job of the order in the partner": "Error al generar el trabajo del pedido en el socio",
  "Failed to load items for PDF": "No se pudieron cargar elementos para PDF",
  "Go Back": "Volver",
  "Loading ink types data. Please wait": "Cargando datos de tipos de tinta. \nEspere por favor",
  "Mail sent": "¡Correo enviado!",
  "Optimize outgoing jobs before sending them to your partner": "Optimice los trabajos salientes antes de enviárselos a su socio",
  "Order Items": "Items de ordern",
  "PDF Preview": "Vista previa de PDF",
  "reply-with-elipsis": "Responder...",
  "Version": "Versión",
  "Wrong URL": "URL incorrecta, inténtalo de nuevo o contacta con el administrador.",
  "Exported": "Exportado",
  "item-moved-to-next-stage": "Artículo movido a la siguiente etapa",
  "failed-to-move-item-to-next-stage": "No se pudo mover el elemento a la siguiente etapa",
  "Select type": "Seleccionar tipo",
  "export-csv": "Exportar CSV",
  "export-excel": "Exportar Excel",
  "group-by": "Agrupar por",
  "export-excel-selection-hint": "Exportando {n} elemento(s) seleccionado(s).",
  "export-excel-filters-hint": "Sin selección: se exportarán los elementos que coincidan con los filtros actuales.",
  "export-excel-bucket-hint": "Se exportarán los elementos de esta agrupación.",
  "Excel exported successfully": "Excel exportado correctamente",
  "There was an error exporting the Excel": "Hubo un error al exportar el Excel",
  "Print job created successfully": "Trabajo de impresión creado exitosamente",
  "Failed to create print job": "No se pudo crear el trabajo de impresión",
  "Remove selected printer from jobs": "Eliminar la impresora seleccionada de los trabajos",
  "No printer": "Sin impresora",
  "Ink consumption": "Consumo de tinta",
  "Percentage": "Porcentaje",
  "Printed length": "Longitud impresa",
  "Print job updated successfully": "Trabajo de impresión actualizado exitosamente",
  "Failed to update print job": "No se pudo actualizar el trabajo de impresión",
  "Edit print job": "Editar trabajo de impresión",
  "width-is-required-and-must-be-greater-than-0": "El ancho es obligatorio y debe ser mayor que 0",
  "length-is-required-and-must-be-greater-than-0": "La longitud es obligatoria y debe ser mayor que 0",
  "Action": "Acción",
  "action": {
    "Nothing": "Ninguna",
    "Queue": "Poner en cola",
    "Print": "Poner en cola e imprimir"
  },
  "no-print-jobs": "Sin trabajos de impresión",
  "quantity-is-required-and-must-be-greater-than-0": "La cantidad es obligatoria y debe ser mayor que 0.",
  "cannot-edit-print-job-in-status-status": "No se puede editar el trabajo de impresión en estado {status}",
  "confirm-remove-from-queue": "Eliminar de la cola",
  "confirm-remove-from-queue-message": "Este trabajo de impresión será eliminado de la cola. ¿Deseas continuar?",
  "no-orders": "Sin órdenes",
  "action-is-required": "Selecciona una acción",
  "cant-print-automatically-without-a-printer-and-scheme": "No se puede imprimir automáticamente sin una impresora y un esquema",
  "cant-print-automatically-with-a-printer-type-destination": "No se puede imprimir automáticamente con una impresora de tipo 'Destination'",
  "Print": "Imprimir...",
  "Print Jobs History": "Historial de trabajos de impresión",
  "New": "Nuevo",
  "no-users-found": "No se encontraron usuarios",
  "this-stage-cannot-be-deleted-because-there-are-order-types-using-it": "Esta etapa no se puede eliminar porque hay tipos de pedido que la están utilizando",
  "this-stage-cannot-be-deleted-because-it-is-set-as-the-default-stage-of-the-workflow": "Esta etapa no se puede eliminar porque está establecida como la etapa predeterminada del flujo de trabajo",
  "this-stage-cannot-be-deleted-because-it-is-set-as-the-default-stage-in-some-of-your-partners-preferences": "Esta etapa no se puede eliminar porque está configurada como la etapa predeterminada en las preferencias de algunos de sus socios",
  "this-stage-cannot-be-deleted-because-it-has-order-items": "Esta etapa no se puede eliminar porque tiene elementos de pedido",
  "move-or-cancel-disabled": "Sólo es posible mover o cancelar trabajos con el estado 'Pendiente' o 'Asignado'",
  "the-item-does-not-exist-or-its-an-item-from-another-company": "El item no existe o es de otra empresa",
  "abort": "Interrumpir",
  "reason-for-aborting": "Motivo de la interrupción",
  "enter-reason-for-aborting": "Ingresa una razón para interrumpir el trabajo de impresión",
  "field-is-required": "Este campo es obligatorio",
  "field-must-have-at-least-n-characters": "Este campo debe tener al menos {n} caracteres",
  "print-job-aborted-successfully": "Trabajo de impresión interrumpido correctamente",
  "Custom field has values and cannot be deleted": "El campo personalizado tiene valores y no se puede eliminar",
  "Go back": "Volver",
  "some-image-files-formats-are-not-supported-in-layouts": "Algunos formatos de imágen de los archivos no son compatibles con las plantillas",
  "Download Log": "Descargar detalles del trabajo",
  "meters-selected": "metros seleccionados",
  "total-meters": "metros totales",
  "New print job": "Nuevo trabajo de impresión",
  "Order Comments": "Comentarios de orden",
  "Item Comments": "Comentarios del item",
  "layout-is-not-compatible-with-this-file-extension": "El diseño no es compatible con esta extensión de archivo",
  "Printers with print jobs cannot be deleted": "Las impresoras con trabajospendientes no se pueden eliminar",
  "you-dont-have-permission-to-edit-print-jobs": "No tienes permiso para editar trabajos de impresión",
  "move-to-stage": "Mover a la etapa {stage}",
  "item-moved-to-stage": "Elemento movido a la etapa {stage}",
  "you-dont-have-permission-to-create-print-jobs": "No tienes permiso para crear trabajos de impresión",
  "the-order-item-is-in-error-status": "El ítem está en estado de error",
  "no-printers-stage-configured": "Necesitas tener una etapa con el Tipo \"Printers\" para crear trabajos de impresión",
  "Order comments": "Comentarios de la orden",
  "Item comments": "Comentarios del item",
  "Delivery date": "Fecha de entrega",
  "Creator": "Creador",
  "deselect-all": "Deseleccionar todo",
  "ASSIGNED": "ASIGNADO",
  "CANCELLED": "CANCELADO",
  "QUEUED": "EN COLA",
  "ABORTED": "FALLIDO",
  "PENDING": "PENDIENTE",
  "PRINTING": "IMPRIMIENDO",
  "Abort date": "Fecha de fallida",
  "Abort Date": "Fecha de fallida",
  "COMPLETED": "COMPLETADO",
  "completed": "Completado",
  "pending": "Pendiente",
  "assigned": "Asignado",
  "processing": "Procesando",
  "queued": "En cola",
  "printing": "Imprimiendo",
  "aborted": "Fallido",
  "cancelled": "Cancelado",
  "Printed Length": "Longitud impresa",
  "Ink Consumption": "Consumo de tinta",
  "End Date": "Fecha final",
  "Archive Date": "Fecha de archivo",
  "there-was-an-error-with-the-item-size-or-position-please-adjust-the-variables-and-try-again": "Ha ocurrido un error con el tamaño o posición del elemento. Por favor, ajuste las variables y vuelva a intentarlo.",
  "and-move-to": "y mover a",
  "PROCESSING": "PROCESANDO",
  "Pause": "Pausar",
  "Resume": "Reanudar",
  "Unknown": "Desconocido",
  "Offline": "Desconectada",
  "Online": "Conectada",
  "Default measurement unit": "Unidad de medida predeterminada",
  "devices-and-apps": "Dispositivos y aplicaciones",
  "qr-reader": "Lector QR",
  "API Tokens": "Claves API",
  "connect-with-neocatalog-to-acces-to-all-your-designs-you-will-be-able-to-create-new-orders-using-any-of-your-neocatalog-designs-and-colorways-with-just-a-click": "Conéctate con neoCatalog para acceder a todos tus diseños. Podrás crear nuevos pedidos usando cualquiera de tus diseños y coloridos de neoCatalog con un solo clic.",
  "connect-with-neocatalog": "Conéctate con neoCatalog",
  "neoCatalog": "neoCatalog",
  "edit-neocatalog-connection": "Editar conexión con neoCatalog",
  "neocatalog-connection-name": "Nombre de la conexión",
  "neocatalog-api-token": "Token API de neoCatalog",
  "neocatalog-api-token-help": "Crea una clave API permanente en neoCatalog (Administración → Gestión → Usuarios → Elige un usuario → API Key) y pégala aquí. ",
  "leave-blank-to-keep-current-token": "Déjalo en blanco para mantener el token actual",
  "neocatalog-connection-created": "neoCatalog conectado correctamente",
  "neocatalog-connection-updated": "Conexión con neoCatalog actualizada",
  "neocatalog-disconnected": "neoCatalog desconectado",
  "do-you-want-to-disconnect-neocatalog": "¿Quieres desconectar neoCatalog?",
  "Error connecting to neoCatalog": "Error al conectar con neoCatalog",
  "Error disconnecting neoCatalog": "Error al desconectar neoCatalog",
  "Connect": "Conectar",
  "Disconnect": "Desconectar",
  "Token": "Token",
  "API Token": "Token API",
  "add-from-neocatalog": "Añadir desde neoCatalog",
  "replace-from-neocatalog": "Reemplazar desde neoCatalog",
  "search-designs-by-name-or-code": "Buscar diseños por nombre o código",
  "search-colorways-by-name-or-code": "Buscar coloridos por nombre o código",
  "no-designs-found": "No se encontraron diseños",
  "no-colorways-found": "No se encontraron coloridos",
  "Error loading neoCatalog designs": "Error al cargar diseños de neoCatalog",
  "Error loading neoCatalog colorways": "Error al cargar coloridos de neoCatalog",
  "Error downloading neoCatalog file": "Error al descargar el archivo de neoCatalog",
  "Next": "Siguiente",
  "Test": "Probar",
  "neocatalog-connection-test-ok": "La conexión con neoCatalog es válida",
  "neocatalog-connection-test-failed": "La prueba de conexión con neoCatalog ha fallado",
  "enter-a-valid-url": "Introduce una URL válida, incluyendo http:// o https://. Se permiten direcciones locales como https://hostname.local:2001.",
  "neocatalog-could-not-reach-server": "No se ha podido alcanzar neoCatalog en esta URL. Comprueba que la dirección es correcta y que el servidor es accesible.",
  "error-replacing-order-item-file-with-neocatalog-file": "Error al reemplazar el archivo del ítem con el archivo de neoCatalog",
  "error-adding-order-item-file-with-neocatalog-file": "Error al agregar el archivo del ítem con el archivo de neoCatalog",
  "Hide Archived": "Ocultar archivados",
  "reset-sort": "Restablecer ordenación",
  "Move to top": "Mover hacia arriba",
  "Move up": "Subir",
  "Move down": "Bajar",
  "Move to bottom": "Mover hacia abajo",
  "reset-sort-to-reorder-manually": "Restablecer ordenación para reordenar manualmente",
  "only-possible-to-move-jobs-with-status": "Sólo es posible mover trabajos con el estado 'Pendiente' o 'Asignado'",
  "OrderItem": "Ítem de orden",
  "PrintJob": "Trabajo de impresión",
  "Configure Order Items Columns": "Configurar columnas de ítems",
  "Drag to reorder and toggle visibility for order item columns": "Arrastra para reordenar y elegir qué columnas se muestran en los ítems.",
  "order-items-dialog-created": "Diálogo de ítems creado",
  "custom-field": "Personalizado",
  "select-partner-stage-tooltip": "Selecciona un workflow stage del tipo Partners para habilitar esta opción",
  "no-partners-available": "No hay socios disponibles",
  "no-partners-available-tooltip": "No hay socios disponibles para tu empresa. Primero agrega socios para usar esta función.",
  "no-accepted-partners": "No hay socios aceptados",
  "no-pending-invitations": "No hay invitaciones pendientes",
  "no-blocked-partners": "No hay socios bloqueados",
  "this-field-is-used-in-a-dialog-and-cannot-be-changed": "Este campo se usa en un diálogo y no se puede cambiar",
  "total": "total",
  "selected": "seleccionado",
  "History": "Historial",
  "material": "Material",
  "no-maximum": "Sin máximo",
  "choose-the-gap-size": "Elija el tamaño del espacio en blanco",
  "print-blank-space-between-materials-in-batch": "Imprimir espacio entre materiales de un lote",
  "print-blank-space-between-batches": "Imprimir espacio entre lotes",
  "force-sequential-jobs-description": "Enviar los trabajos en el orden de la cola. El siguiente trabajo espera hasta que el trabajo anterior de la misma impresora haya terminado de procesarse.",
  "Information": "Información",
  "controlCenterErrors": {
    "printJobStuck": "Error: El trabajo de impresión lleva mucho tiempo en estado de procesamiento",
    "fileUrlMissing": "Error: Falta la URL del archivo.",
    "errorDownloadingFile": "Error al descargar el archivo:",
    "errorSendingOrder": "Error: Error al enviar el pedido al servidor de impresión",
    "jobRemovedFromQueue": "Error: El trabajo ha sido eliminado de la cola."
  },
  "add-description": "Añadir descripción...",
  "No preview available": "No hay vista previa disponible",
  "Editing is disabled because item is already accepted": "La edición está deshabilitada porque el elemento ya ha sido aceptado"
}
